<template>
  <div id="app">
    <div v-if="$store.state.auth.isLoggedIn">
      <div id="main-wrapper">
        <Aside />
        <Header />
        <div class="page-wrapper">
          <router-view />
        </div>
      </div>
      <Floating />
    </div>
    <div v-else class="layout-light side-menu main-wrapper not-log-in">
      <main class="main-content">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import Aside from '@/components/layouts/Aside.vue'
import Header from '@/components/layouts/Header.vue'
import Floating from '@/components/layouts/Floating.vue'

export default {
  components: { Aside, Header, Floating },
  watch: {
    '$route'() {
      setTimeout(() => this.initTemplate(), 300)
    },
    '$store.state.auth.isLoggedIn'() {
      this.initTemplate()
    },
  },
  mounted() {
    this.initTemplate()
  },
  methods: {
    initTemplate() {},
  },
}
</script>

<style>
.spinner { height: 1rem !important; width: 1rem !important; }
.vm--modal {
  height: auto !important;
  max-height: 95% !important;
  overflow-y: auto !important;
  position: fixed !important;
  color: #272b41 !important;
  background: #fff !important;
  color-scheme: light;
}
.vm--modal .text-muted {
  color: #6c757d !important;
}
.vm--modal .form-control,
.vm--modal select.form-control,
.vm--modal input.form-control,
.vm--modal textarea.form-control {
  background-color: #fff !important;
  border-color: #ced4da !important;
  color: #495057 !important;
}
.vm--modal .form-control:focus {
  background-color: #fff !important;
  border-color: #128c7e !important;
  color: #495057 !important;
  box-shadow: 0 0 0 0.15rem rgba(18, 140, 126, 0.2);
}
.vm--modal .custom-control-label,
.vm--modal label,
.vm--modal h5,
.vm--modal h4,
.vm--modal p {
  color: #272b41;
}
.vm--modal .text-muted,
.vm--modal label.small.text-muted,
.vm--modal .small.text-muted {
  color: #6c757d !important;
}
.vm--modal option {
  background-color: #fff;
  color: #495057;
}
hr { margin-top: 20px !important; margin-bottom: 20px !important; }
</style>
